const CalendarIcon = ({ width = 12, height = 14, className = '', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M11.25 5.83329H0.75M8.33333 1.16663V3.49996M3.66667 1.16663V3.49996M3.55 12.8333H8.45C9.43009 12.8333 9.92014 12.8333 10.2945 12.6426C10.6238 12.4748 10.8915 12.2071 11.0593 11.8778C11.25 11.5034 11.25 11.0134 11.25 10.0333V5.13329C11.25 4.1532 11.25 3.66315 11.0593 3.28881C10.8915 2.95953 10.6238 2.69181 10.2945 2.52403C9.92014 2.33329 9.43009 2.33329 8.45 2.33329H3.55C2.56991 2.33329 2.07986 2.33329 1.70552 2.52403C1.37623 2.69181 1.10852 2.95953 0.940739 3.28881C0.75 3.66315 0.75 4.1532 0.75 5.13329V10.0333C0.75 11.0134 0.75 11.5034 0.940739 11.8778C1.10852 12.2071 1.37623 12.4748 1.70552 12.6426C2.07986 12.8333 2.56991 12.8333 3.55 12.8333Z"
      stroke="#686576"
      strokeWidth={1.16667}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CalendarIcon;
